@use 'style/utils';

$_counter-ctl-margin: 10px;
$_component_width: 200px;
$CLASS: '.joy-counter';

:host {
    /**
     * @prop --counter-items-height: Set a new value for this property, and it will resize both buttons and input
     */
    --counter-items-height: var(--joy-form-field-height-small);

    --counter-input-color: var(--joy-color-secondary-50);
    --counter-input-bg-color: var(--joy-color-secondary-10);
    --counter-input-bg-color-focus: white;

    --counter-input-border-color-invalid: var(--joy-color-error-50);
    --counter-input-color-invalid: var(--joy-color-error-50);
    --counter-input-border-color-invalid-hover: var(--joy-color-error-90);
    --counter-input-color-invalid-hover: var(--joy-color-error-90);

    --counter-button-bg-color: var(--joy-color-secondary-10);
    --counter-button-bg-color-hover: var(--joy-color-secondary-50);
    --counter-button-bg-color-active: var(--joy-color-secondary-50);
    --counter-button-bg-color-disabled: var(--joy-color-neutral-30);
    --counter-button-color: var(--joy-color-secondary-50);

    --counter-border-color-focus: var(--joy-color-neutral-60);

    display: inline-flex;
    flex-wrap: wrap;
    max-width: $_component_width;
    align-items: center;
    justify-content: center;
    position: relative;
    @include utils.getFontProperties(primary-400);
}

#{$CLASS}__wrapper {
    display: inline-flex;
    flex-wrap: wrap;
    max-width: $_component_width;
    align-items: center;
    justify-content: center;
    position: relative;

    input {
        @include utils.quietInput(var(--joy-form-border-width) solid transparent);
        background-color: var(--counter-input-bg-color);
        color: var(--counter-input-color);
        width: 80px;
        outline: none;
        height: var(--counter-items-height);
        border-radius: var(--joy-core-radius-2);
        text-align: center;
        -moz-appearance:textfield;
        box-sizing: border-box;

        &::-webkit-inner-spin-button,
        &::-webkit-outer-spin-button {
            -webkit-appearance: none;
        }

        @include utils.formElementColorHover();
        @include utils.formElementColorFocus() {
            background-color: var(--counter-input-bg-color-focus);
        }

        &.joy-counter__invalid {
            &, &:focus-visible {
                border-color: var(--counter-input-border-color-invalid);
                color: var(--counter-input-color-invalid);
            }

            &:hover {
                border-color: var(--counter-input-border-color-invalid-hover);
                color: var(--counter-input-color-invalid-hover);
            }
        }
    }

    button {
        @include utils.quietBtn();
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        width: var(--counter-items-height);
        height: var(--counter-items-height);
        border-radius: var(--joy-core-radius-6);
        background-color: var(--counter-button-bg-color);
        color: var(--counter-button-color);
        transition: background var(--joy-transition-duration-default) var(--joy-transition-timing-function);

        &:before {
            content: "";
            position: absolute;
            top: -1px;
            left: -1px;
            border-radius: 50%;
            width: calc(100% + 2px);
            height: calc(100% + 2px);
            transition: box-shadow var(--joy-transition-duration-default) var(--joy-transition-timing-function);
        }

        &:hover {
            background-color: var(--counter-button-bg-color-hover);

            &:not(:disabled) {
                &.joy-counter__increment joy-icon, &.joy-counter__decrement joy-icon {
                    color: white;
                }
            }
        }

        &:focus-visible {
            &:before {
                box-shadow: 0 0 0 2px var(--counter-border-color-focus);
            }
        }

        &:active {
            background-color: var(--counter-button-bg-color-active);
        }

        &:disabled {
            background-color: var(--counter-button-bg-color-disabled);
            cursor: not-allowed;

            joy-icon {
                color: white;
            }
        }

        &.joy-counter__increment {
            margin-left: $_counter-ctl-margin;
        }

        &.joy-counter__decrement {
            margin-right: $_counter-ctl-margin;
        }
    }

    .joy-counter_error {
        flex-basis: 100%;
        max-width: 100%;
        margin-top: 20px;
    }
}
